import './index.scss';
import util from '../util';
import store from '../store';
class YoutubePlayer {
  constructor(config) {
    this.$store = {
      youtubeid: '',
      poster: store('isMobile') ? `https://img.youtube.com/vi/${config.youtubeid}/sddefault.jpg` : `https://img.youtube.com/vi/${config.youtubeid}/sddefault.jpg`,
      youtubeLink: false,
      controls: false,
      autoplay: false,
      loop: false,
      mute: true,
      preload: false,
      oldIE: /msie 10|msie 9/i.test(navigator.userAgent.toLocaleLowerCase()),
      isMobile: store('isMobile'),
      isIphone: store('isIphone'),
      isIpad: store('isIpad'),
      isPlay: false,
      canPlay: false,
      isLeadyPoster: false,
      playQ: false,
      controlImportant: false,
      timer: false,
      uniqueId: '',
      top: 0,
      ...config
    };
    this.$dom = {};
    this.$el = $(config.el);
    this.$video = null;
    this.$animationFrame = new util.animationFrame(() => {
      this.updateProgress();
      this.updateTime();
    });

    this.$fixScrollTop = new util.animationFrame(() => {
      if (!$('html').hasClass('promokit-fullscreen-ios')) {
        this.$fixScrollTop.stop();
      }

      $('html, body').scrollTop(this.$store.top);
    });

    this.$el.addClass('promokit-youtube');
    this.$store.oldIE && this.$el.addClass(`promokit-youtube--ie`);

    if (window.loadedYoutubeApi) {
      this.loadPlayer();
    }
    else {
      this.loadYoutubeApi();
      $(window).on('loadedYoutubeApi', () => {
        this.loadPlayer();
      });
    }

    if (this.$store.preload) {
      store('preloadLength.youtube', Number(store('preloadLength.youtube')) + 1);
    }

    this.$store.uniqueId = `youtube.${util.uniqueId()}`;
    this.$el.attr('data-store', this.$store.uniqueId);
    store(this.$store.uniqueId, this);
  }

  loadYoutubeApi() {
    if (window.loadYoutubeApi) return;
    window.loadYoutubeApi = true;
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      window.loadedYoutubeApi = true;
      $(window).trigger('loadedYoutubeApi');
    };
  }

  loadPlayer() {
    let uniqueId = Math.random().toString(36).substr(2, 9) + this.$store.youtubeid;
    let template = `<div class="promokit-youtube__bg"></div> 
                    <div class="promokit-youtube__screen-wrap">
                      <div id="promokit-youtube__${uniqueId}" class="promokit-youtube__screen"></div>
                    </div>`;

    this.$el.append(template);
    this.$video = new window.YT.Player(`promokit-youtube__${uniqueId}`, {
      width: '100%',
      height: '100%',
      videoId: this.$store.youtubeid,
      host: 'https://www.youtube.com',
      playerVars: {
        rel: 0,
        showinfo: 0,
        controls: 0,
        playsinline: 1,
        origin: window.location.host
      }
    });

    this.$dom.screenWrap = this.$el.find('.promokit-youtube__screen-wrap');

    this.setYoutubeEvent();
    this.setFullScreenChangeEvent();
    this.setContextEvent();

    $(window).on('resize', () => {
      this.updateScreenSize();
    });
  }

  loadCover() {
    const img = new Image();
    img.addEventListener('load', () => {
      //setTimeout(()=>{this.handleLoadPoster()}, 200)
      this.handleLoadPoster();
    });
    img.src = this.$store.poster;

    const template = `<div class="promokit-youtube__poster" style="background:url('${this.$store.poster}') #000 no-repeat 50% 50%"></div>
        <div class="promokit-youtube__cover"></div>`;

    const controls = this.$el.append(template);

    this.$dom.cover = controls.find(`.promokit-youtube__cover`);
    this.$dom.poster = controls.find(`.promokit-youtube__poster`);
  }

  loadControls() {
    const template = `<div class="promokit-youtube__controls">
            <div class="promokit-youtube__controls-spinner"></div>
            <div class="promokit-youtube__controls-progress">
              <div class="promokit-youtube__controls-progress-time"></div>
              <div class="promokit-youtube__controls-progress-bar"></div>
            </div>
            <button class="promokit-youtube__controls-button promokit-youtube__controls-button--play">재생</button>
            <button class="promokit-youtube__controls-button promokit-youtube__controls-button--pause">정지</button>
            
           <div class="promokit-youtube__time"></div>
            
            <button class="promokit-youtube__mute-button promokit-youtube__mute-button--off">
              <svg version="1.1" viewBox="0 0 36 36">
                <path d="M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"></path>
                <path d="M 9.25,9 7.98,10.27 24.71,27 l 1.27,-1.27 Z"></path>
              </svg>
            </button>
            <button class="promokit-youtube__mute-button promokit-youtube__mute-button--on">
              <svg version="1.1" viewBox="0 0 36 36" >
                <path d="M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"></path>
              </svg>
            </button>
            <button class="promokit-youtube__fullscreen-button promokit-youtube__fullscreen-button--off">
              <svg version="1.1" viewBox="0 0 36 36">
                <g><path d="m 14,14 -4,0 0,2 6,0 0,-6 -2,0 0,4 0,0 z"></path></g>
                <g><path d="m 22,14 0,-4 -2,0 0,6 6,0 0,-2 -4,0 0,0 z"></path></g>
                <g><path d="m 20,26 2,0 0,-4 4,0 0,-2 -6,0 0,6 0,0 z"></path></g>
                <g><path d="m 10,22 4,0 0,4 2,0 0,-6 -6,0 0,2 0,0 z"></path></g>
              </svg>
            </button>
            <button class="promokit-youtube__fullscreen-button promokit-youtube__fullscreen-button--on">
              <svg  version="1.1" viewBox="0 0 36 36" >
                <g><path d="m 10,16 2,0 0,-4 4,0 0,-2 L 10,10 l 0,6 0,0 z"></path></g>
                <g><path d="m 20,10 0,2 4,0 0,4 2,0 L 26,10 l -6,0 0,0 z"></path></g>
                <g><path d="m 24,24 -4,0 0,2 L 26,26 l 0,-6 -2,0 0,4 0,0 z"></path></g>
                <g><path d="M 12,20 10,20 10,26 l 6,0 0,-2 -4,0 0,-4 0,0 z"></path></g>
              </svg>
            </button>
            ${this.$store.youtubeLink ? `<a class="promokit-youtube__link" target="_blank" href="https://www.youtube.com/watch?v=${this.$store.youtubeid}">
    <svg height="100%" version="1.1" viewBox="0 0 110 26" width="100%"><use class="ytp-svg-shadow" xlink:href="#ytp-id-13"></use>
    <path class="ytp-svg-fill" d="M 16.68,.99 C 13.55,1.03 7.02,1.16 4.99,1.68 c -1.49,.4 -2.59,1.6 -2.99,3 -0.69,2.7 -0.68,8.31 -0.68,8.31 0,0 -0.01,5.61 .68,8.31 .39,1.5 1.59,2.6 2.99,3 2.69,.7 13.40,.68 13.40,.68 0,0 10.70,.01 13.40,-0.68 1.5,-0.4 2.59,-1.6 2.99,-3 .69,-2.7 .68,-8.31 .68,-8.31 0,0 .11,-5.61 -0.68,-8.31 -0.4,-1.5 -1.59,-2.6 -2.99,-3 C 29.11,.98 18.40,.99 18.40,.99 c 0,0 -0.67,-0.01 -1.71,0 z m 72.21,.90 0,21.28 2.78,0 .31,-1.37 .09,0 c .3,.5 .71,.88 1.21,1.18 .5,.3 1.08,.40 1.68,.40 1.1,0 1.99,-0.49 2.49,-1.59 .5,-1.1 .81,-2.70 .81,-4.90 l 0,-2.40 c 0,-1.6 -0.11,-2.90 -0.31,-3.90 -0.2,-0.89 -0.5,-1.59 -1,-2.09 -0.5,-0.4 -1.10,-0.59 -1.90,-0.59 -0.59,0 -1.18,.19 -1.68,.49 -0.49,.3 -1.01,.80 -1.21,1.40 l 0,-7.90 -3.28,0 z m -49.99,.78 3.90,13.90 .18,6.71 3.31,0 0,-6.71 3.87,-13.90 -3.37,0 -1.40,6.31 c -0.4,1.89 -0.71,3.19 -0.81,3.99 l -0.09,0 c -0.2,-1.1 -0.51,-2.4 -0.81,-3.99 l -1.37,-6.31 -3.40,0 z m 29.59,0 0,2.71 3.40,0 0,17.90 3.28,0 0,-17.90 3.40,0 c 0,0 .00,-2.71 -0.09,-2.71 l -9.99,0 z m -53.49,5.12 8.90,5.18 -8.90,5.09 0,-10.28 z m 89.40,.09 c -1.7,0 -2.89,.59 -3.59,1.59 -0.69,.99 -0.99,2.60 -0.99,4.90 l 0,2.59 c 0,2.2 .30,3.90 .99,4.90 .7,1.1 1.8,1.59 3.5,1.59 1.4,0 2.38,-0.3 3.18,-1 .7,-0.7 1.09,-1.69 1.09,-3.09 l 0,-0.5 -2.90,-0.21 c 0,1 -0.08,1.6 -0.28,2 -0.1,.4 -0.5,.62 -1,.62 -0.3,0 -0.61,-0.11 -0.81,-0.31 -0.2,-0.3 -0.30,-0.59 -0.40,-1.09 -0.1,-0.5 -0.09,-1.21 -0.09,-2.21 l 0,-0.78 5.71,-0.09 0,-2.62 c 0,-1.6 -0.10,-2.78 -0.40,-3.68 -0.2,-0.89 -0.71,-1.59 -1.31,-1.99 -0.7,-0.4 -1.48,-0.59 -2.68,-0.59 z m -50.49,.09 c -1.09,0 -2.01,.18 -2.71,.68 -0.7,.4 -1.2,1.12 -1.49,2.12 -0.3,1 -0.5,2.27 -0.5,3.87 l 0,2.21 c 0,1.5 .10,2.78 .40,3.78 .2,.9 .70,1.62 1.40,2.12 .69,.5 1.71,.68 2.81,.78 1.19,0 2.08,-0.28 2.78,-0.68 .69,-0.4 1.09,-1.09 1.49,-2.09 .39,-1 .49,-2.30 .49,-3.90 l 0,-2.21 c 0,-1.6 -0.2,-2.87 -0.49,-3.87 -0.3,-0.89 -0.8,-1.62 -1.49,-2.12 -0.7,-0.5 -1.58,-0.68 -2.68,-0.68 z m 12.18,.09 0,11.90 c -0.1,.3 -0.29,.48 -0.59,.68 -0.2,.2 -0.51,.31 -0.81,.31 -0.3,0 -0.58,-0.10 -0.68,-0.40 -0.1,-0.3 -0.18,-0.70 -0.18,-1.40 l 0,-10.99 -3.40,0 0,11.21 c 0,1.4 .18,2.39 .68,3.09 .49,.7 1.21,1 2.21,1 1.4,0 2.48,-0.69 3.18,-2.09 l .09,0 .31,1.78 2.59,0 0,-14.99 c 0,0 -3.40,.00 -3.40,-0.09 z m 17.31,0 0,11.90 c -0.1,.3 -0.29,.48 -0.59,.68 -0.2,.2 -0.51,.31 -0.81,.31 -0.3,0 -0.58,-0.10 -0.68,-0.40 -0.1,-0.3 -0.21,-0.70 -0.21,-1.40 l 0,-10.99 -3.40,0 0,11.21 c 0,1.4 .21,2.39 .71,3.09 .5,.7 1.18,1 2.18,1 1.39,0 2.51,-0.69 3.21,-2.09 l .09,0 .28,1.78 2.62,0 0,-14.99 c 0,0 -3.40,.00 -3.40,-0.09 z m 20.90,2.09 c .4,0 .58,.11 .78,.31 .2,.3 .30,.59 .40,1.09 .1,.5 .09,1.21 .09,2.21 l 0,1.09 -2.5,0 0,-1.09 c 0,-1 -0.00,-1.71 .09,-2.21 0,-0.4 .11,-0.8 .31,-1 .2,-0.3 .51,-0.40 .81,-0.40 z m -50.49,.12 c .5,0 .8,.18 1,.68 .19,.5 .28,1.30 .28,2.40 l 0,4.68 c 0,1.1 -0.08,1.90 -0.28,2.40 -0.2,.5 -0.5,.68 -1,.68 -0.5,0 -0.79,-0.18 -0.99,-0.68 -0.2,-0.5 -0.31,-1.30 -0.31,-2.40 l 0,-4.68 c 0,-1.1 .11,-1.90 .31,-2.40 .2,-0.5 .49,-0.68 .99,-0.68 z m 39.68,.09 c .3,0 .61,.10 .81,.40 .2,.3 .27,.67 .37,1.37 .1,.6 .12,1.51 .12,2.71 l .09,1.90 c 0,1.1 .00,1.99 -0.09,2.59 -0.1,.6 -0.19,1.08 -0.49,1.28 -0.2,.3 -0.50,.40 -0.90,.40 -0.3,0 -0.51,-0.08 -0.81,-0.18 -0.2,-0.1 -0.39,-0.29 -0.59,-0.59 l 0,-8.5 c .1,-0.4 .29,-0.7 .59,-1 .3,-0.3 .60,-0.40 .90,-0.40 z" id="ytp-id-13"></path>
    </svg>
    </a>` : ''}
            
        </div>`;

    const controls = this.$el.append(template);

    this.$dom.controls = controls.find(`.promokit-youtube__controls`);
    this.$dom.spinner = controls.find(`.promokit-youtube__controls-spinner`);
    this.$dom.progress = controls.find(`.promokit-youtube__controls-progress`);
    this.$dom.progressBar = controls.find(`.promokit-youtube__controls-progress-bar`);
    this.$dom.progressTime = controls.find(`.promokit-youtube__controls-progress-time`);
    this.$dom.play = controls.find(`.promokit-youtube__controls-button--play`);
    this.$dom.pause = controls.find(`.promokit-youtube__controls-button--pause`);
    this.$dom.fullscreenOn = controls.find(`.promokit-youtube__fullscreen-button--on`);
    this.$dom.fullscreenOff = controls.find(`.promokit-youtube__fullscreen-button--off`);
    this.$dom.muteOn = controls.find(`.promokit-youtube__mute-button--on`);
    this.$dom.muteOff = controls.find(`.promokit-youtube__mute-button--off`);
    this.$dom.time = controls.find(`.promokit-youtube__time`);

    this.setControlsEvent();
  }

  updateProgress() {
    if (!this.$store.controls) return;

    let bar = (this.currentTime / this.duration);
    this.$dom.progressBar.css({ 'transform': `scaleX(${bar > 1 ? 1 : bar})` });
    if (!this.$store.enabledTime) {
      this.$dom.progress.addClass(`promokit-youtube__controls-progress--no-hour`);
    }
  }

  updateTime() {
    if (!this.$store.controls) return;

    if (!this.$store.enabledTime) {
      this.$dom.progress.addClass(`promokit-youtube__controls-progress--no-hour`);
    }

    this.$dom.time.text(`- ${this.getTimeString(this.duration - this.currentTime)}`);
  }

  updateScreenSize() {
    let setWidth = 0;
    let setHeight = 0;
    let contextWidth = this.$el[0].offsetWidth;
    let contextHeight = this.$el[0].offsetHeight;
    let videoWidth = 960;
    let videoHeight = 540;

    if ((contextWidth / contextHeight) < (videoWidth / videoHeight)) {
      setWidth = contextHeight * videoWidth / videoHeight;
      setHeight = contextHeight;
    }
    else {
      setWidth = contextWidth;
      setHeight = contextWidth * videoHeight / videoWidth;
    }

    this.$dom.screenWrap.css({
      width: `${setWidth}px`,
      height: `${setHeight}px`
    });

    this.$dom.poster?.css({
      width: `${setWidth}px`,
      height: `${setHeight}px`
    });
  }

  visibleControls(q) {
    if (q) {
      this.$el.addClass(`promokit-youtube--show-controls`);
    }
    else {
      if (this.$store.controlImportant) return;
      this.$el.removeClass(`promokit-youtube--show-controls`);
    }
  }

  hideTimer() {
    clearTimeout(this.$store.hideTimer);

    this.$store.hideTimer = setTimeout(() => {
      this.$store.controlImportant = false;
      this.visibleControls(false);
    }, 2000);
  }

  setYoutubeEvent() {
    let Event = {
      0: 'ended',
      1: 'play',
      2: 'pause',
      3: 'waiting'
    };
    this.$video.addEventListener('onStateChange', e => {
      if (e.data === -1 || e.data === 5) return;
      this.$el.trigger(Event[`${e.data}`]);
    });

    this.$video.addEventListener('onReady', this.handleCanplay.bind(this));
  }

  setControlsEvent() {
    this.$dom.play.on('click', this.play.bind(this));
    this.$dom.pause.on('click', this.pause.bind(this));
    this.$dom.muteOn.on('click', this.mute.bind(this));
    this.$dom.muteOff.on('click', this.unMute.bind(this));
    this.$dom.fullscreenOn.on('click', this.handleFullScreenStart.bind(this));
    this.$dom.fullscreenOff.on('click', this.handleFullScreenEnd.bind(this));
    this.$dom.progress.on('click', (e) => {
      this.$animationFrame.stop();
      this.$dom.poster.addClass(`promokit-youtube__poster--hide`);
      let progressWidth = this.$dom.progress.width();
      this.$dom.progressBar.css('transform', `scaleX(${e.offsetX / progressWidth})`);
      this.seek((1 - (progressWidth - e.offsetX) / progressWidth) * this.duration);
      this.updateTime();
    });

    if (this.$store.isMobile) {
      this.$dom.cover.on('click', () => {
        this.visibleControls(true);
        this.hideTimer();
      });

      this.$dom.controls.on('transitionend', (e) => {
        if ($(e.target).css('opacity') == 0) {
          this.$dom.cover.show();
        }
        else {
          this.$dom.cover.hide();
        }
      });
    }

    if (!this.$store.isMobile) {
      this.$el.on('mousemove', () => {
        if (!this.$store.isPlay) return;
        clearTimeout(this.$store.timer);
        this.visibleControls(true);
        this.$store.timer = setTimeout(() => {
          if (!this.$store.isPlay) return;
          if (this.$store.controlImportant) return;
          this.visibleControls(false);
        }, 1000);
      });

      this.$dom.progress.on('mousemove', (e) => {
        this.$dom.progressTime.show();
        this.$dom.progressTime.css('left', e.offsetX);

        let progressWidth = this.$dom.progress.width();
        //  (1 - (progressWidth - e.offsetX) / progressWidth) * this.duration |> parseInt |> this.getTimeString |> this.$dom.progressTime.text;
      });

      this.$dom.progress.on('mouseover', () => {
        this.visibleControls(true);
        this.$store.controlImportant = true;
      });

      this.$dom.progress.on('mouseout', () => {
        this.visibleControls(false);
        this.$store.controlImportant = false;
        this.$dom.progressTime.hide();
      });
    }
  }

  setContextEvent() {
    this.$el.on('play', () => {
      this.$store.isPlay = true;
      this.$animationFrame.stop();
      this.$animationFrame.start();
      this.$el.addClass(`promokit-youtube--play`);
      this.$el.removeClass(`promokit-youtube--waiting promokit-youtube--ended`);
      this.$el.removeClass(`promokit-youtube--pause`);
      this.$dom.poster.addClass(`promokit-youtube__poster--hide`);
      this.visibleControls(false);

      if (this.$store.controls) {
        let newList = store('nowPlayingList');
        newList.push(`${this.$store.uniqueId}`);
        store('nowPlayingList', newList);
      }
    });

    this.$el.on('pause', () => {
      this.$store.isPlay = false;
      this.updateProgress();
      this.$el.addClass(`promokit-youtube--pause`);
      this.$el.removeClass(`promokit-youtube--play promokit-youtube--waiting`);
      this.visibleControls(true);
      this.$animationFrame.stop();

      if (this.$store.controls) {
        store('nowPlayingList', _.remove(store('nowPlayingList'), (playingId) => {
          return playingId != this.$store.uniqueId;
        }));
      }
    });

    this.$el.on('ended', () => {
      this.$store.isPlay = false;
      this.$el.addClass(`promokit-youtube--ended`);
      this.$el.removeClass(`promokit-youtube--play promokit-youtube--waiting`);
      this.$dom.poster.removeClass(`promokit-youtube__poster--hide`);
      this.$animationFrame.stop();

      if (this.$store.controls) {
        store('nowPlayingList', _.remove(store('nowPlayingList'), (playingId) => {
          return playingId != this.$store.uniqueId;
        }));
      }

      if (this.$store.loop) {
        this.pause();
        this.seek(0);
        this.play();
      }
      else {
        this.$dom.cover.hide();
        this.visibleControls(true);
      }
    });

    this.$el.on('waiting ', () => {
      this.$el.addClass(`promokit-youtube--waiting`);
    });

    this.$el.on('fullscreenstart ', () => {
      this.$el.addClass(`promokit-youtube--fullscreen`);
    });

    this.$el.on('fullscreenend', () => {
      this.$el.removeClass(`promokit-youtube--fullscreen`);
      store('isFullscreenVideo', false);
    });

    this.$el.on('mute', () => {
      this.$el.addClass(`promokit-youtube--mute`);
    });

    this.$el.on('unMute', () => {
      this.$el.removeClass(`promokit-youtube--mute`);
    });

    this.$el.on('stop', () => {
      this.$store.isPlay = false;
      this.$animationFrame.stop();
      this.$el.addClass(`promokit-youtube--ended`);
      this.$el.removeClass(`promokit-youtube--play promokit-youtube--waiting`);
      this.$dom.poster.removeClass(`promokit-youtube__poster--hide`);
      this.visibleControls(true);
      this.$dom.progressBar && this.$dom.progressBar.css({ 'transform': `scaleX(0)` });

      if (this.$store.controls) {
        store('nowPlayingList', _.remove(store('nowPlayingList'), (playingId) => {
          return playingId != this.$store.uniqueId;
        }));
      }
    });

    this.$el.on('transitionend', function (e) {
      e.stopPropagation();
    });
  }

  setFullScreenChangeEvent() {
    if (this.$store.oldIE) {
      $(window).on('keydown.fullscreen', e => {
        if (e.keyCode === '27') {
          this.handleFullScreenEnd();
        }
      });
      return;
    }
    if (util.screenfull.isEnabled) {
      util.screenfull.on('change', () => {
        if (util.screenfull.isFullscreen) {
          this.$el.trigger('fullscreenstart');
        }
        else {
          this.$el.trigger('fullscreenend');
        }

        this.updateScreenSize();
      });
    }
  }

  getTimeString(t) {
    let hour = Math.floor(t / 60 / 60);
    let min = Math.floor(t / 60 % 60);
    let sec = Math.floor(t % 60);

    if (sec < 0) {
      sec = '0';
    }

    if (min < 0) {
      min = '0';
    }

    if (sec < 10) {
      sec = `0${sec}`;
    }

    if (hour > 0) {
      hour = `${hour}:`;
      min = `${min > 10 ? '' : '0'}${min}:`;
    }
    else {
      hour = '';
      min = `${min}:`;
    }

    return `${hour}${min}${sec}`;
  }

  handleCanplay() {
    if (this.$store.canPlay) return;

    this.$store.enabledTime = Math.floor(this.duration / 60 / 60) > 0;
    this.loadCover();
    this.$store.controls && this.loadControls();
    this.$el.addClass(`promokit-youtube--ready`);
    // this.$el.trigger('canplay');

    if (this.$store.preload) {
      store('preloadLength.youtube', Number(store('preloadLength.youtube')) - 1);
    }

    this.$store.canPlay = true;
    if (this.$store.isLeadyPoster) {
      this.$el.trigger('canplay');
    };
    this.updateTime();
    this.updateScreenSize();
    this.$store.mute && this.mute();
    this.$store.autoplay && this.autoplay();
  }

  handleLoadPoster() {
    this.$store.isLeadyPoster = true;
    if (this.$store.canPlay) {
      this.$el.trigger('canplay');
    };

  }
  handleFullScreenStart() {
    if (store('isFullscreenVideo')) return;

    let htmlTop = $('html').scrollTop();
    let bodyTop = $('body').scrollTop();

    this.$store.top = (htmlTop < 1 && bodyTop < 0) ? 0 : htmlTop > 0 ? htmlTop : bodyTop;

    this.$el.addClass(`promokit-youtube--fullscreen`);
    store('isFullscreenVideo', true);


    if (this.$store.isIphone || this.$store.isIpad) {
      this.$el.parents().each(function () {
        $(this).addClass('promokit-fullscreen-ios');
      });
    }
    else {
      if (util.screenfull.isEnabled) {
        util.screenfull.request(this.$el[0]);
      }
    }

    this.$animationFrame.stop();
    this.$video.loadVideoById(this.$store.youtubeid, this.currentTime);
  }

  handleFullScreenEnd() {
    this.$el.removeClass(`promokit-youtube--fullscreen`);

    store('isFullscreenVideo', false);

    this.$fixScrollTop.start();

    if (this.$store.isIphone || this.$store.isIpad) {
      this.$el.parents().each(function () {
        $(this).removeClass('promokit-fullscreen-ios');
      });
      return;
    }

    if (util.screenfull.isEnabled) {
      util.screenfull.exit();
    }

    this.$animationFrame.stop();
  }

  on(e, eventListener) {
    this.$el.on(e, eventListener);
  }

  off(e) {
    this.$el.off(e);
  }

  autoplay() {
    this.mute();
    this.play(true);
  }

  play() {
    if (this.$store.canPlay) {
      this.$video.playVideo();
    }
    else {
      this.$store.playQ = true;
      this.$el.on('canplay.q', () => {
        this.$store.playQ && this.$video.playVideo();
      });
    }
  }

  stop() {
    this.$store.playQ = false;
    if (!this.$store.isPlay) return;

    this.pause();
    this.seek(0);
    this.$el.trigger('stop');
  }

  pause() {
    this.$store.playQ = false;
    if (!this.$store.isPlay) return;

    this.$video.pauseVideo();
  }

  mute() {
    this.$video.mute();
    this.$el.trigger('mute');
  }

  unMute() {
    this.$video.unMute();
    this.$el.trigger('unMute');
  }

  seek(t) {
    this.$video.seekTo(t);
    this.$el.trigger('seek');
  }

  get duration() {
    return this.$video.getDuration();
  }

  get currentTime() {
    return this.$video.getCurrentTime();
  }
}

export default YoutubePlayer;
